import { api } from "../api";

/**
 * deviceEventActionFindAllByDevice - Function that finds on database all avent-actions (automatic commands)  
 * devices/event-actions/{deviceId}  
 * method GET  
 * @async-function
 */
const deviceEventActionFindAllByDevice = async (token: string, deviceId: number, page: number, size: number) => {
    const response = await api.get(
        `devices/event-actions/${deviceId}?page=${page}&size=${size}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default deviceEventActionFindAllByDevice;